

export class ReceiverInfo {
    id: number;
    receiverId:any;
    senderId:any;
    senderPhone:string;
    receiverName: string;
    receiverPhone: string;
    shippingAddress: string;
    toWardId?: number = null;
    toDistrictId?: number = null;
    toProvinceId?: number = null;
    toWardName: string;
    toDistrictName: string;
    toProvinceName: string;
    addressNoteTo: string;
    toHubId?: number = null;
    toHubCode: string;
    toHubName: string;

}